"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Spinner = exports.LogoContainer = exports.LoaderContainer = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const LoaderContainer = _styledComponents.default.div`
  background: ${props => props.backgroundColor};
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10;
  height: 100vh;
  width: 100%;
  overflow: hidden;
`;
exports.LoaderContainer = LoaderContainer;
const LogoContainer = _styledComponents.default.div`
  align-items: center;
  bottom: 28%;
  display: flex;
  height: unset;
  justify-content: center;
  left: 0;
  margin: auto;
  position: absolute;
  right: 0;
  top: 28%;
  width: unset;
`;
exports.LogoContainer = LogoContainer;
const Spinner = _styledComponents.default.span`
  width: 84px;
  height: 84px;
  border-radius: 50%;
  position: absolute;
  animation: rotate 1s linear infinite;
  &::before {
    content: '';
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 5px solid ${props => props.color || 'white'};
    animation: dash 2s linear infinite;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0%,
    100% {
      clip-path: polygon(50% 50%, 0 0, 0 0, 0 0, 0 0, 0 0);
    }
    25%,
    75% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 0, 100% 0, 100% 0);
    }
    50% {
      clip-path: polygon(50% 50%, 0 0, 100% 0, 100% 100%, 100% 100%, 100% 100%);
    }
  }
`;
exports.Spinner = Spinner;
//# sourceMappingURL=styles.js.map